// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.ShoppingExtensions.InventoryList.Cell.View'
,	[
	'c3_shoppingextensions_inventorylist_cell.tpl'
	
	,	'SCView'
	//,   'C3.ShoppingExtensions.Carousel.View'
	,   'AjaxRequestsKiller'
	//,	'Backbone'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
	,   'Backbone.CollectionView'
	,   'Facets.CategoryCell.View'
    ]
, function (
	c3_shoppingextensions_inventorylist_cell_tpl
	
	,	SCViewModule
	//,   CarouselView
	,   AjaxRequestsKiller
	//,	Backbone
	,   GlobalViewsBreadcrumbView
	,   Utils
	,   BackboneCollectionView
	,   FacetsCategoryCellView
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

     function InventoryListCellView (options) {
     	SCView.call(this, options);

     	  this.template = c3_shoppingextensions_inventorylist_cell_tpl;
        this.options = options;
	     this.application = options.application;
	     this.model = options.model;
	   //console.log(options)
     }

     InventoryListCellView.prototype = Object.create(SCView.prototype);
     InventoryListCellView.prototype.constructor = InventoryListCellView;


     /*InventoryListCellView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }*/

    InventoryListCellView.prototype.getContext = function () {
    	console.log(this.model.get('img'))
    	return {
				name : this.model.get('name'),
				imgData : this.model.get('img')
			};
    }

     return InventoryListCellView;

});
